export const formatCredits = (value: number | null): string => {
  if (value == null || Number.isNaN(value)) return '—';
  const amount = Number.isInteger(value) ? String(value) : value.toFixed(2);
  return value > 0 ? `+${amount}` : amount;
};
